exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-hobbies-archive-tsx": () => import("./../../../src/templates/hobbies-archive.tsx" /* webpackChunkName: "component---src-templates-hobbies-archive-tsx" */),
  "component---src-templates-projects-archive-tsx": () => import("./../../../src/templates/projects-archive.tsx" /* webpackChunkName: "component---src-templates-projects-archive-tsx" */)
}

